import { BottomSheet } from 'doctornow-design-system';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const SleepDisorderGuideBottomSheet = ({ isOpen, onClose }: Props) => {
  return (
    <BottomSheet
      type='single'
      title={
        <>
          졸피뎀 등 향정신성 의약품은
          <br />
          비대면 처방이 어려워요
        </>
      }
      description='멜라토닌, 항히스타민제 등은 비대면 처방이 가능해요!'
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      buttons={[
        {
          label: '확인했어요',
          variant: 'primary',
          onClick: onClose,
        },
      ]}
    >
      <div className='flex justify-center'>
        <img
          src='https://media.doctornow.co.kr/web_diagnosis_warning.webp'
          alt='sleep disorder guide'
          className='h-[160px] w-[312px] object-contain'
        />
      </div>
    </BottomSheet>
  );
};

export default SleepDisorderGuideBottomSheet;
